import axios from 'axios'

const allAxiosCommonRequest = async function (props = {}) {
    let token = localStorage.getItem('isloggedIn')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNumber')
    let congData =
    {
        //customerNo: customerNo,
        //customerNumber: customerNo,
        //userId: userId,
        ...props.Items
    }
    let response = 
    /* await axios.post("https://dev-scctgateway.elixia.tech/transporter-allocation/aws/dashboard", {
            "dashboard_id": "3d22e4ce-b8e4-4310-81ab-f68fd4be003a"
        }) */
    await axios.request({
        //baseURL: props.baseURL ? props.baseURL : APP_CONSTANT.BASE_COMMON,
        baseURL: process.env.REACT_APP_TA_API_URL,//'https://dev-commongateway.elixia.tech',
        url: '/aws/dashboard',
        method: props.method,
        data: props.method != 'get' ? congData : '',   
    })
    let resp = new Promise((resolve, reject) => {
        if (response.status === 200) {
            resolve(response)
        } else {
            reject(response)
        }
    })
    return resp;
}
export default allAxiosCommonRequest